// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1IdCu","title":"Info_title__3VkEF","links":"Info_links___GCon","link":"Info_link__3dHz1","logo":"Info_logo__12xd0"};